import { state } from 'cerebral/tags'
import { compute } from 'cerebral'

export default namespace => {
  return compute(state`selectr.${namespace}.selected`, (options, get) => {
    return options.reduce((acc, option, index) => {
      if (option.selected) {
        const { label, focused, selectedIndex = -1 } = option
        acc.push({
          label,
          index,
          focused,
          selectedIndex
        })
      }
      return acc
    }, [])
  })
}
